import React from "react";

import "./Detail.css";

const Detail = props => {
  const { children, icon, title, description } = props;

  return (
    <div className="detail pad-8 mar-h-16 c-black-60">
      <i className={`fal ${icon} fs-36`} />
      <h4 className="fs-18 fw-bold lh-lg c-black-60">{title}</h4>
      <p className="fs-16 lh-lg c-black-60 mar-0 pad-0 desc">{description}</p>
      {children}
    </div>
  );
};

export default Detail;



// WEBPACK FOOTER //
// ./src/Components/Header/Detail/Detail.js